<!--
 * @message: 分页器
 * @Author: cjc
 * @since: 2019-12-16 19:59:14
 * @lastTime: 2019-12-18 11:06:58
 * @LastAuthor: cjc
 -->
<template>
  <div class="pagination-container">
    <ul class="pagination-wrapper">
      <li v-for="item in length" :key="item" @click="$emit('update', currPagination = item)">
        <span v-if="item === currPagination" class="icon pagination_curr">
          <img :class="'icon pagination_num' + item" src="@/assets/images/img_trans.png"/>
        </span>
        <img v-else :class="'icon pagination_num' + item" src="@/assets/images/img_trans.png"/>
      </li>
      <button class="icon pagination_prev" @click="toPrevPagination"></button>
      <button class="icon pagination_next" @click="toNextPagination"></button>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'pagination-comp',
  data () {
    return {
    }
  },
  computed: {
    hasPrev () {
      return this.currPagination > 1
    },
    hasNext () {
      return this.currPagination < this.length
    }
  },
  methods: {
    toPrevPagination () {
      this.hasPrev &&
        this.currPagination-- &&
        this.$emit('update', this.currPagination)
    },
    toNextPagination () {
      this.hasNext &&
        this.currPagination++ &&
        this.$emit('update', this.currPagination)
    }
  },
  props: ['length', 'currPagination']
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/mixins.scss";
.pagination-container {
  @include size(100%, 195px);
  @include flex-center;
  .pagination-wrapper {
    @include p-relative;
    @include inline-flex(center, center);
    padding: 0 40px;
    li {
      @include inline-flex(center, center);
      @include size(54px, 66px);
      text-align: center;
      span {
        @include inline-flex(center, center);
      }
    }
  }
  .pagination_prev {
    @include p-absolute(0, 0, top, left);
  }
  .pagination_next {
    @include p-absolute(0, 0, top, right);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subpage/pagination.vue